import { sendAnalytics } from '@storefront/app/analytics/SimpleTriggerEvent';
import { env } from 'next-runtime-env';
import { uiEvents } from '@storefront/services/DataCollection/simpleUiEvents';
import { TFunction } from 'react-i18next';

const sendAnalyticsHLC = (href: string, controlName: string) => {
  const productAnalytics = uiEvents.disclaimerGenericHLCprinter;
  sendAnalytics({
    simpleUiEvent: { ...productAnalytics, controlName, controlDetail: href },
  });
};

export const getTranslatedComponents = (t: TFunction) => ({
  myAccount: {
    href: env('NEXT_PUBLIC_MY_ACCOUNT'),
    id: 'disclaimer-my-account-link',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'MyAccount'),
  },
  hpOnePrivacy: {
    href: t('termsOfService.termsOfService'),
    id: 'disclaimer-hp-one-privacy-link',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'TermsOfService'),
  },
  proLiveSupport: {
    href: t('termsOfService.proLiveSupport'),
    id: 'disclaimer-pro-live-support',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'ProLiveSupport'),
  },
  nextDayReplacement: {
    href: t('termsOfService.nextDayReplacement'),
    id: 'disclaimer-next-day-replacement',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'NextBusinessDayReplacement'),
  },
  mobilePrinting: {
    href: t('termsOfService.mobilePrinting'),
    id: 'disclaimer-mobile-printing',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'MobilePrinting'),
  },
  hpAi: {
    href: t('termsOfService.hpAi'),
    id: 'disclaimer-hp-ai',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'HpAi'),
  },
});
